var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx--list-box bx--dropdown bx--skeleton",class:{ 'bx--list-box--inline': _vm.inline },attrs:{"disabled":""}})}
var staticRenderFns = []

export { render, staticRenderFns }